import {Component, EventEmitter, Output} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FormStatus} from '@iw-shop/forms/components/submit-button/submit-button.component';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {UserService} from '@iw-shop/user/services/user.service';

@Component({
    selector: 'iw-shop-user-password-update',
    standalone: false,
    templateUrl: './user-password-update.component.html',
    styleUrls: ['./user-password-update.component.scss']
})
export class UserPasswordUpdateComponent {
    @Output() onUpdateSuccess: EventEmitter<any> = new EventEmitter();

    destroy$: Subject<boolean> = new Subject<boolean>();

    userId?: string;

    apiError?: {
        notification: string,
        errors?: { key: string, error: string }[]
    };
    form: FormGroup;

    formStatus: FormStatus = null;

    constructor(protected fb: FormBuilder, protected store: Store<AppState>, private userService: UserService) {

        this.form = this.fb.group({
            password: this.fb.control(null, [Validators.required, Validators.minLength(6)]),
            passwordRetype: this.fb.control(null)
        });
        this.store.select(state => state.user)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                r => {
                    if (r.id) {
                        this.userId = r.id;
                    }
                }
            );
    }

    isFormRequestError(value: string): boolean {
        let form = this.form?.get(value);
        return !!(form?.errors &&
            this.formStatus == 'submitForm');
    }

    validateForm(): boolean {

        if (this.form.get('password')?.value != this.form.get('passwordRetype')?.value) {
            this.form.get('passwordRetype')?.setErrors({'incorrect': true})
        }
        return true;
    }

    setUpdateSuccess() {
        this.onUpdateSuccess.emit();
    }


    submit() {
        this.formStatus = 'submitForm';
        this.validateForm();
        if (this.form.valid) {
            this.formStatus = 'loading';
            this.userService.update({id: this.userId ?? '', password: this.form.get('password')?.value})
                .subscribe(
                    {
                        next: r => {
                            this.formStatus = 'submitForm';
                            if (r.error) {
                                this.apiError = {notification: r.error.message};
                                if (r.error.input) {
                                    this.apiError.errors = r.error.input;
                                }
                                window.scroll({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth'
                                });
                            } else {
                                this.formStatus = 'success';
                                setTimeout(() => {
                                    if (r.result?.users.updated) {
                                        this.form.reset();
                                        this.setUpdateSuccess();
                                    }
                                    this.formStatus = null;
                                }, 1000);
                            }
                        },
                        error: () => {
                            this.formStatus = 'submitForm';
                        }
                    }
                )
        }
    }


}
